import React, { useEffect, useRef, useState } from 'react';
import { ProductCard } from '../ProductCard/ProductCard';

const ScrollableProductCarousel = ({ searchResults, onProductSelect, isMobile }) => {
  const containerRef = useRef(null);
  const [cardsToShow, setCardsToShow] = useState(4);
  const [cardWidth, setCardWidth] = useState(250);

  console.log("ScrollableProductCarousel rendered with searchResults:", searchResults);
  
  // Recalculate cards to show and card width on resize
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      let newCards = 4;
      let newWidth = 250;
      
      if (screenWidth < 480) {
        newCards = 2;
        newWidth = 150;
      } else if (screenWidth < 768) {
        newCards = 2;
        newWidth = 180;
      } else if (screenWidth < 1024) {
        newCards = 3;
        newWidth = 220;
      }
      
      setCardsToShow(newCards);
      setCardWidth(newWidth);
    };

    handleResize(); // on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollByCards = (direction) => {
    const container = containerRef.current;
    if (container) {
      const scrollAmount = direction * cardWidth * cardsToShow;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  // More compact heights for mobile
  const containerHeight = cardWidth < 180 ? 340 : cardWidth < 220 ? 380 : 470;
  const cardHeight = cardWidth < 180 ? 320 : cardWidth < 220 ? 360 : 450;

  return (
    <div style={{ 
      position: 'relative', 
      width: '100%', 
      margin: cardWidth < 180 ? '20px 0 0 0' : '35px 0 0 0', 
      minHeight: containerHeight 
    }}>
      {/* Left Button */}
      <button
        style={scrollButtonStyle('left', cardWidth)}
        onClick={() => scrollByCards(-1)}
        aria-label="Scroll left"
      >
        &#8592;
      </button>

      {/* Carousel Container */}
      <div
        ref={containerRef}
        style={{
          overflowX: 'auto',
          display: 'flex',
          gap: cardWidth < 180 ? '12px' : '16px',
          padding: cardWidth < 180 ? '0 5px' : cardWidth < 220 ? '5px 15px' : '5px 30px',
          scrollBehavior: 'smooth',
          height: `${containerHeight}px`,
        }}
        className="hide-scrollbar"
      >
        {searchResults.map(product => (
          <div
            key={product.id}
            style={{
              minWidth: cardWidth,
              maxWidth: cardWidth,
              flex: '0 0 auto',
              height: cardHeight,
              cursor: 'pointer',
            }}
            onClick={() => {
              if (onProductSelect) onProductSelect(product);
            }}
          >
            <ProductCard {...product} />
          </div>
        ))}
      </div>

      {/* Right Button */}
      <button
        style={scrollButtonStyle('right', cardWidth)}
        onClick={() => scrollByCards(1)}
        aria-label="Scroll right"
      >
        &#8594;
      </button>

      {/* Hide scrollbar styling */}
      <style>{`
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
};

const scrollButtonStyle = (side, cardWidth) => {
  const buttonSize = cardWidth < 180 ? 32 : cardWidth < 220 ? 36 : 40;
  const buttonOffset = cardWidth < 180 ? -5 : 0;
  
  return {
    position: 'absolute',
    [side]: buttonOffset,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
    background: '#fff',
    border: '1px solid #ccc',
    borderRadius: '50%',
    width: buttonSize,
    height: buttonSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    fontSize: cardWidth < 180 ? '14px' : '16px',
  };
};

export default ScrollableProductCarousel;
